"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import { PencilIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";
import { AuthContext } from "@/components/auth/Auth";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
interface WaveDropActionsEditProps {
  readonly drop: ExtendedDrop;
  readonly onEdit: () => void;
  readonly isDropdownItem?: boolean | undefined;
}
export default function WaveDropActionsEdit(t0) {
  const $ = _c(15);
  const {
    drop,
    onEdit,
    isDropdownItem: t1
  } = t0;
  const isDropdownItem = t1 === undefined ? false : t1;
  const {
    connectedProfile
  } = useContext(AuthContext);
  if (connectedProfile?.handle !== drop.author.handle) {
    return null;
  }
  if (isDropdownItem) {
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <PencilIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" />;
      t3 = <span className="tw-text-sm tw-font-medium">Edit</span>;
      $[0] = t2;
      $[1] = t3;
    } else {
      t2 = $[0];
      t3 = $[1];
    }
    let t4;
    if ($[2] !== onEdit) {
      t4 = <button type="button" onClick={onEdit} className="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-0 tw-bg-transparent tw-px-3 tw-py-2 tw-text-iron-300 tw-transition-colors tw-duration-200 desktop-hover:hover:tw-bg-iron-800">{t2}{t3}</button>;
      $[2] = onEdit;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  const t2 = `edit-drop-${drop.id}`;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PencilIcon className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-p-[1px] tw-transition tw-duration-300 tw-ease-out" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onEdit || $[6] !== t2) {
    t4 = <button type="button" className="tw-flex tw-h-7 tw-w-7 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-iron-400 tw-transition-all tw-duration-200 tw-ease-out desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-200" onClick={onEdit} aria-label="Edit" data-tooltip-id={t2}>{t3}</button>;
    $[5] = onEdit;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `edit-drop-${drop.id}`;
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    };
    t7 = <span className="tw-text-xs">Edit Message</span>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5) {
    t8 = <Tooltip id={t5} place="top" offset={8} opacity={1} style={t6}>{t7}</Tooltip>;
    $[10] = t5;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t4 || $[13] !== t8) {
    t9 = <>{t4}{t8}</>;
    $[12] = t4;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}